import { createAuthorizationHeader } from '@ff-os/shared-utils/private-urls';
import { urls } from '@ff-os/shared-utils/urls';
import { AppThunkApi, PdpState } from '../../store';
import { withAuthorization } from '../authorization/withAuthorization';
import { createAsyncAppThunk } from '../createAsyncAppThunk';

export const loadExternalUploaders = createAsyncAppThunk<undefined, ListResponse>(
    'externalUpload/load',
    async (_, thunkApi: AppThunkApi) => {

        const response = await withAuthorization(async (state: PdpState) => {
            return fetch(urls.listExternalUploaders, formatRequest(state));
        }, thunkApi);

        if (response.ok) {
            return await response.json() as ListResponse;
        } else {
            throw new Error(`Error while loading external uploaders`);
        }
    });

const formatRequest = (state: PdpState): RequestInit => ({
    method: 'GET',
    mode: 'cors',
    headers: createAuthorizationHeader(state.auth.jwt!)
});

type ListResponse = {
    entries: ListEntry[];
};

type ListEntry = {
    id: string;
    url: string;
    createdOn: number;
    expiresOn: number;
    settings: any;
};